import $ from "jquery";
const NOT_FOUND = -1;

$(".applications__filter-nav li a").on("click", function filterByTag(e) {
  e.preventDefault();
  const tag = $(e.target).data("tag");
  $("[data-tags]").css("display", "none");
  $("[data-tags]").each(function filterElements() {
    let tags;
    if($(this).data("tags")
      .toString()
      .indexOf(",") > NOT_FOUND) {
      tags = $(this).data("tags")
        .split(",");
    } else {
      tags = [$(this).data("tags")];
    }
    for(let j = 0; j < tags.length; j++) {
      if(tags[j] === tag) {
        $(this).css("display", "");
      }
    }
  });
});



// WEBPACK FOOTER //
// ./src/assets/js/applications_filter.js